<div class="page-content-wrapper">
  <div class="card shadow rounded-3 border-1">
    <div class="card-header bg-white border-0 me-2 d-flex justify-content-between align-items-center">
      <p class="text-s fw-bold">User Management</p>
    </div>
    <div class="card-body">
      <CustomTabs :tabs="tabs" v-model="currentTab" />

      <div class="tab-content">

        <div v-if="currentTab === 'client_profile'" class="tab-pane fade show active">
          <div class="row mt-4">
            <div class="card card-description border-3 col">
              <div class="decorative-card">
                <div class="row">
                  <h6 class="mb-3 text-lg fw-bold">Client: {{ first_name }} {{ last_name }}</h6>
                  <span class="text-xs fw-bold">Email Address: <span class="ms-sm-2 fw-light text-dark">{{ email }}</span></span>
                  <span class="text-xs fw-bold">Date Joined: <span class="ms-sm-2 fw-light text-dark">{{ formatDate(date_joined) }}</span></span>
                </div>
              </div>
              <hr class="horizontal dark">
              <p class="text-uppercase text-sm text-blue fw-bold">Edit User Information</p>
              <form>
                <div class="row mb-3">
                  <div class="col">
                    <label class="form-label fw-bold"><small>First name</small></label>
                    <input v-model="first_name" type="text" class="form-control text-xs" placeholder="First name" name="first_name"
                      @input="validate_name('first_name')" required>
                    <div class="first-name-message d-none">First name is required</div>
                  </div>
                  <div class="col">
                    <label class="form-label fw-bold"><small>Last name</small></label>
                    <input v-model="last_name" type="text" class="form-control text-xs" placeholder="Last name" name="last_name"
                      @input="validate_name('last_name')" required>
                    <div class="last-name-message d-none">Last name is required</div>
                  </div>
                </div>
                <div class="row mb-3">
                  <div class="col">
                    <label class="form-label fw-bold"><small>Email</small></label>
                    <input v-model="email" type="email" class="form-control text-xs" placeholder="Email" name="email">
                    <div class="email-message d-none">Email is required</div>
                  </div>
                  <div class="col">
                    <label class="form-label fw-bold"><small>Phone number</small></label>
                    <input v-model="phone_number" type="tel" class="form-control text-xs" placeholder="Enter phone number"
                      maxlength="10" @input="validate_phone_number" required>
                    <div class="phone-number-message d-none">Phone number must be 10 digits</div>
                  </div>
                </div>
                <div class="modal-footer">
                  <button type="submit" class="btn bg-green btn-sm text-xs fw-bold rounded-pill"
                    @click.prevent="edit_user(get_user_id)">Submit</button>
                </div>
              </form>
            </div>
          </div>
        </div>

        <div v-if="currentTab === 'assign_permission'" class="tab-pane fade show active">
          <div class="row mt-4">
            <div class="col-12">
              <div class="card shadow rounded-3 border-1 p-3">
                <div class="card-body custom-table-container w-100">
                  <div class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center mb-3 border-bottom pb-2">
                    <h6 class="text-lg fw-bold">Workflow Creation Management</h6>
                    <button class="btn bg-green btn-sm text-xxs fw-bold rounded-3 shadow"
                      @click="loadClientsWithPermissions" :disabled="isLoadingPermissions">
                      <span v-if="isLoadingPermissions">
                        <span class="spinner-border spinner-border-sm me-2" role="status"></span>
                        Loading...
                      </span>
                      <span v-else>Refresh</span>
                    </button>
                  </div>

                  <div class="d-flex justify-content-end align-items-center mb-3">
                    <span class="input-group-text border-0 bg-transparent" id="search-addon">
                      <i class="fas fa-search text-muted"></i>
                    </span>
                    <input type="text" class="form-control rounded-3 w-25" placeholder="Search clients..."
                      v-model="searchTerm">
                  </div>

                  <div v-if="isLoadingPermissions && permissionUsers.length === 0" class="text-center py-4">
                    <div class="spinner-border text-primary" role="status">
                      <span class="visually-hidden">Loading...</span>
                    </div>
                    <p class="text-xs mt-2">Loading client permissions...</p>
                  </div>

                  <div v-else>
                    <div class="table-responsive">
                      <table class="table table-striped table-hover w-100">
                        <thead class="table-dark">
                          <tr>
                            <th class="text-xs fw-bold">#</th>
                            <th class="text-xs fw-bold">Client Details</th>
                            <th class="text-xs fw-bold">Workflow Creation</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(user, index) in paginatedUsers" :key="user.id">
                            <td class="text-xxs">{{ index + 1 + (currentPage - 1) * entriesPerPage }}</td>
                            <td class="text-xxs">
                              <div>{{ user.first_name }} {{ user.last_name }}</div>
                              <div class="fw-bold">{{ user.email }}</div>
                            </td>
                            <td>
                              <div class="form-check">
                                <input type="checkbox" class="form-check-input workflow_checkbox"
                                  :id="`workflow_${user.id}`" :data-user-id="user.id" data-role="workflow access"
                                  v-model="user.workflow_access"
                                  @change="updateUserRole(user.id, 'workflow_access', $event.target.checked)">
                                <label class="form-check-label text-xs" :for="`workflow_${user.id}`">
                                  {{ user.workflow_access ? 'Granted' : 'Not Granted' }}
                                </label>
                              </div>
                            </td>
                          </tr>
                          <tr v-if="paginatedUsers.length === 0 && !isLoadingPermissions">
                            <td colspan="3" class="text-center text-xs py-4">
                              <div v-if="searchTerm">
                                No clients found matching "{{ searchTerm }}".
                              </div>
                              <div v-else>
                                No clients available for permission assignment.
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>

                    <div v-if="totalPages > 1" class="d-flex justify-content-between align-items-center mt-3">
                      <div class="text-xs text-muted">
                        Showing {{ ((currentPage - 1) * entriesPerPage) + 1 }} to
                        {{ Math.min(currentPage * entriesPerPage, filteredUsers.length) }} of
                        {{ filteredUsers.length }} entries
                        <span v-if="searchTerm">(filtered from {{ permissionUsers.length }} total)</span>
                      </div>
                      <nav>
                        <ul class="pagination pagination-sm mb-0">
                          <li class="page-item" :class="{ disabled: currentPage === 1 }">
                            <a class="page-link" href="#" @click.prevent="currentPage = Math.max(1, currentPage - 1)">Previous</a>
                          </li>
                          <li v-for="page in totalPages" :key="page" class="page-item"
                            :class="{ active: currentPage === page }">
                            <a class="page-link" href="#" @click.prevent="currentPage = page">{{ page }}</a>
                          </li>
                          <li class="page-item" :class="{ disabled: currentPage === totalPages }">
                            <a class="page-link" href="#" @click.prevent="currentPage = Math.min(totalPages, currentPage + 1)">Next</a>
                          </li>
                        </ul>
                      </nav>
                    </div>

                    <div v-if="permissionUsers.length > 0" class="mt-3 p-3 bg-light rounded">
                      <div class="row text-xs">
                        <div class="col"><strong>Total Clients:</strong> {{ permissionUsers.length }}</div>
                        <div class="col"><strong>With Workflow Creation Rights:</strong> {{ permissionUsers.filter(u => u.workflow_access).length }}</div>
                        <div class="col"><strong>Without Workflow Creation Rights:</strong> {{ permissionUsers.filter(u => !u.workflow_access).length }}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>